import * as Sentry from '@sentry/browser'
import { useUserContext } from '../../components/UserLogic/context'
import apiRequest from '../../util/request'

export const useAddOrUpdateCartOption = () => {
  const { reducerState: userReducerState } = useUserContext()

  return async (optionKey: string, optionBody: any) => {
    try {
      await apiRequest(`/cart/options/${optionKey}`, {
        method: 'PUT',
        jwt: userReducerState.jwt,
        body: JSON.stringify(optionBody),
      })
    } catch (error) {
      Sentry.captureException(error)
      console.error('Error updating cart options:', error)
      throw error
    }
  }
}
